// Regole Scoperti e Franchigie per Zona (Local Persistence Support)

const STORAGE_KEY = 'mobility_safe_deductibles';

const defaultDeductiblesRules = {
  furtoIncendioTotale: {
    name: "Furto / Incendio Totale",
    emoji: "🔴",
    appliesTo: ["Base", "Medium", "Collisione", "Kasko"],
    rules: {
      "1": { scoperto: "0%", franchigia: "€0" },
      "2": { scoperto: "0%", franchigia: "€0" },
      "3": { scoperto: "0%", franchigia: "€0" },
      "3bis": { scoperto: "0%", franchigia: "€0" },
      "4": { scoperto: "10%", franchigia: "€500" }
    }
  },
  furtoParziale: {
    name: "Furto Parziale",
    emoji: "🔴",
    appliesTo: ["Base", "Medium", "Collisione", "Kasko"],
    rules: {
      "1": { scoperto: "10%", franchigia: "€250" },
      "2": { scoperto: "10%", franchigia: "€250" },
      "3": { scoperto: "10%", franchigia: "€250" },
      "3bis": { scoperto: "10%", franchigia: "€250" },
      "4": { scoperto: "15%", franchigia: "€500" }
    }
  },
  eventiNaturaliVandalismo: {
    name: "Eventi Naturali / Vandalismo",
    emoji: "🟠",
    appliesTo: ["Medium", "Collisione", "Kasko"],
    limit: "€6.000 per sinistro",
    rules: {
      "1": { scoperto: "10%", franchigia: "€250" },
      "2": { scoperto: "10%", franchigia: "€250" },
      "3": { scoperto: "15%", franchigia: "€350" },
      "3bis": { scoperto: "15%", franchigia: "€350" },
      "4": { scoperto: "15%", franchigia: "€500" }
    }
  },
  animaliSelvatici: {
    name: "Animali Selvatici",
    emoji: "🟡",
    appliesTo: ["Medium", "Collisione", "Kasko"],
    limit: "€3.000 / anno",
    rules: {
      "1": { scoperto: "10%", franchigia: "€250" },
      "2": { scoperto: "10%", franchigia: "€250" },
      "3": { scoperto: "10%", franchigia: "€250" },
      "3bis": { scoperto: "10%", franchigia: "€250" },
      "4": { scoperto: "15%", franchigia: "€500" }
    }
  },
  collisione: {
    name: "Collisione",
    emoji: "🔵",
    appliesTo: ["Collisione"],
    rules: {
      "1": { scoperto: "10%", franchigia: "€600" },
      "2": { scoperto: "10%", franchigia: "€600" },
      "3": { scoperto: "10%", franchigia: "€600" },
      "3bis": { scoperto: "10%", franchigia: "€600" },
      "4": { scoperto: "15%", franchigia: "€600" }
    }
  },
  kasko: {
    name: "Kasko",
    emoji: "🟣",
    appliesTo: ["Kasko"],
    rules: {
      "1": { scoperto: "10%", franchigia: "€750" },
      "2": { scoperto: "10%", franchigia: "€750" },
      "3": { scoperto: "10%", franchigia: "€750" },
      "3bis": { scoperto: "10%", franchigia: "€750" },
      "4": { scoperto: "15%", franchigia: "€1.250" }
    }
  }
};

let activeRules = null;

export const loadDeductiblesRules = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        activeRules = saved ? JSON.parse(saved) : defaultDeductiblesRules;
    } catch (e) {
        activeRules = defaultDeductiblesRules;
    }
    return activeRules;
};

export const saveDeductiblesRules = (newRules) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newRules));
    activeRules = newRules;
};

export const getDeductiblesRules = () => {
    if (!activeRules) loadDeductiblesRules();
    return activeRules;
};

export const getDeductiblesForPackage = (packageType, zone) => {
  const result = [];
  const rules = getDeductiblesRules();
  
  Object.entries(rules).forEach(([key, rule]) => {
    if (rule.appliesTo.includes(packageType)) {
      const zoneRule = rule.rules[zone];
      if (zoneRule) {
        result.push({
          id: key,
          name: rule.name,
          emoji: rule.emoji,
          scoperto: zoneRule.scoperto,
          franchigia: zoneRule.franchigia,
          limite: rule.limit || null
        });
      }
    }
  });
  
  return result;
};

// For backward compatibility
export const deductiblesRules = getDeductiblesRules();